import { render, staticRenderFns } from "./SectionDownloads.vue?vue&type=template&id=575fc3ca&scoped=true&"
import script from "./SectionDownloads.vue?vue&type=script&lang=js&"
export * from "./SectionDownloads.vue?vue&type=script&lang=js&"
import style0 from "./SectionDownloads.vue?vue&type=style&index=0&id=575fc3ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575fc3ca",
  null
  
)

export default component.exports